export default __webpack_public_path__ + "static/media/searchBlack.ef83c507.svg";